import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng';

@Injectable({ providedIn: 'root' })
export class PriceChangeReasonsService {
  url = '/api/price-change-reasons';

  constructor(public http: HttpClient) {}

  public getPriceChangeReasons(): Promise<SelectItem[]> {
    return this.http.get<SelectItem[]>(`${this.url}`).toPromise();
  }
}
